module.exports = __webpack_public_path__ + "img/Lulu-Flight-Kitchen.8e7ce629.jpg";